import type { SxProps } from '@mui/material';

const BLUE = '#2AA2E4';
const ORANGE = '#FE730F';
const LEAF_SIZE = 20.918;
const MASK_RADIUS = 4.933;
export const LEAVES = [
    {
        id: 'tl',
        color: ORANGE,
        path: 'M20.918 20.918L10.459 20.918C4.683 20.918 0 16.235 0 10.459C0 4.683 4.683 0 10.459 0C16.235 0 20.918 4.683 20.918 10.459L20.918 20.918Z',
        cx: 10.393,
        cy: 10.223,
        r: MASK_RADIUS,
        size: LEAF_SIZE
    },
    {
        id: 'tr',
        color: BLUE,
        path: 'M0 20.918L0 10.459C0 4.683 4.683 0 10.459 0C16.236 0 20.918 4.683 20.918 10.459C20.918 16.235 16.236 20.918 10.459 20.918L0 20.918Z',
        cx: 10.447,
        cy: 10.331,
        r: MASK_RADIUS,
        size: LEAF_SIZE
    },
    {
        id: 'bl',
        color: BLUE,
        path: 'M20.918 0L20.918 10.459C20.918 16.235 16.235 20.918 10.459 20.918C4.683 20.918 0 16.235 0 10.459C0 4.683 4.683 0 10.459 0L20.918 0Z',
        cx: 10.393,
        cy: 10.459,
        r: MASK_RADIUS,
        size: LEAF_SIZE
    },
    {
        id: 'br',
        color: BLUE,
        path: 'M0 0H10.459C16.235 0 20.918 4.683 20.918 10.459C20.918 16.235 16.235 20.918 10.459 20.918C4.683 20.918 0 16.235 0 10.459V0Z',
        cx: 10.459,
        cy: 10.459,
        r: MASK_RADIUS,
        size: LEAF_SIZE
    }
] as const;
export const S = 52; // leaf size px

const G = 3; // gap px

export const DUR = '2.8s';
export const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const KEYFRAMES_CSS = `
@keyframes taytan-leaf-tl {
    0%   { transform: translate(0, 0) rotate(0deg) scale(1); opacity: 1; }
    8%   { transform: translate(30px, 30px) rotate(30deg) scale(0.85); }
    25%  { transform: translate(120px, 90px) rotate(160deg) scale(0.6); opacity: 0.7; }
    50%  { transform: translate(80px, -60px) rotate(90deg) scale(0.7); }
    75%  { transform: translate(-50px, 40px) rotate(-60deg) scale(0.8); opacity: 0.9; }
    100% { transform: translate(0, 0) rotate(0deg) scale(1); opacity: 1; }
}
@keyframes taytan-leaf-tr {
    0%   { transform: translate(${S + G}px, 0) rotate(0deg) scale(1); opacity: 1; }
    8%   { transform: translate(${S + G - 30}px, 30px) rotate(-30deg) scale(0.85); }
    25%  { transform: translate(-100px, 80px) rotate(-160deg) scale(0.6); opacity: 0.7; }
    50%  { transform: translate(-60px, -70px) rotate(-90deg) scale(0.7); }
    75%  { transform: translate(${S + G + 40}px, -40px) rotate(60deg) scale(0.8); opacity: 0.9; }
    100% { transform: translate(${S + G}px, 0) rotate(0deg) scale(1); opacity: 1; }
}
@keyframes taytan-leaf-bl {
    0%   { transform: translate(0, ${S + G}px) rotate(0deg) scale(1); opacity: 1; }
    8%   { transform: translate(30px, ${S + G - 30}px) rotate(30deg) scale(0.85); }
    25%  { transform: translate(110px, -90px) rotate(160deg) scale(0.6); opacity: 0.7; }
    50%  { transform: translate(60px, 80px) rotate(90deg) scale(0.7); }
    75%  { transform: translate(-40px, ${S + G + 30}px) rotate(-60deg) scale(0.8); opacity: 0.9; }
    100% { transform: translate(0, ${S + G}px) rotate(0deg) scale(1); opacity: 1; }
}
@keyframes taytan-leaf-br {
    0%   { transform: translate(${S + G}px, ${S + G}px) rotate(0deg) scale(1); opacity: 1; }
    8%   { transform: translate(${S + G - 30}px, ${S + G - 30}px) rotate(-30deg) scale(0.85); }
    25%  { transform: translate(-110px, -80px) rotate(-160deg) scale(0.6); opacity: 0.7; }
    50%  { transform: translate(-70px, 70px) rotate(-90deg) scale(0.7); }
    75%  { transform: translate(${S + G + 40}px, ${S + G + 30}px) rotate(60deg) scale(0.8); opacity: 0.9; }
    100% { transform: translate(${S + G}px, ${S + G}px) rotate(0deg) scale(1); opacity: 1; }
}
`;
export const ANIM_NAMES = ['taytan-leaf-tl', 'taytan-leaf-tr', 'taytan-leaf-bl', 'taytan-leaf-br'] as const;
export const INITIAL_TRANSFORMS = [
    'translate(0, 0) rotate(0deg) scale(1)',
    `translate(${S + G}px, 0) rotate(0deg) scale(1)`,
    `translate(0, ${S + G}px) rotate(0deg) scale(1)`,
    `translate(${S + G}px, ${S + G}px) rotate(0deg) scale(1)`
] as const;
export const SIZE_BOX = { width: S * 2 + G, height: S * 2 + G } as const satisfies SxProps;
